(function () {
  'use strict';

  const BAR_ID = 'mobile-cart-bar';
  const MOBILE = () => window.innerWidth <= 749;
  const ON_BONBONS = () => window.location.pathname === '/collections/bonbons';

  function injectBar() {
    if (document.getElementById(BAR_ID)) return;

    const bar = document.createElement('div');
    bar.id = BAR_ID;
    bar.innerHTML = `
      <div class="mcb-left">
        <span class="mcb-badge" id="mcb-count">0</span>
        <span class="mcb-price" id="mcb-price">€0,00</span>
      </div>
      <div class="mcb-right">
        <button class="mcb-btn mcb-btn--ghost" id="mcb-view-cart" type="button">Doosje bekijken</button>
        <button class="mcb-btn" name="gift-checkout" id="gift-checkout-trigger" type="button">Afrekenen</button>
      </div>
    `;
    document.body.appendChild(bar);
    injectStyles();

    // Doosje bekijken opent de drawer via de originele functie
    document.getElementById('mcb-view-cart').addEventListener('click', function () {
      const drawer = document.querySelector('cart-drawer');
      if (drawer && drawer._originalOpen) drawer._originalOpen();
      else if (drawer) drawer.open();
    });
  }

  function injectStyles() {
    if (document.getElementById('mcb-styles')) return;
    const style = document.createElement('style');
    style.id = 'mcb-styles';
    style.textContent = `
      @media (max-width: 749px) {
        #${BAR_ID} {
          position: fixed;
          bottom: 1.2rem;
          left: 1rem;
          right: 1rem;
          background: #111;
          color: #fff;
          border-radius: 14px;
          padding: .9rem 1rem;
          display: none;
          align-items: center;
          justify-content: space-between;
          z-index: 99998;
          box-shadow: 0 8px 30px rgba(0,0,0,0.25);
        }
        #${BAR_ID}.mcb-visible { display: flex; }

        .mcb-left {
          display: flex;
          align-items: center;
          gap: .7rem;
        }
        .mcb-badge {
          background: #C9A84C;
          color: #111;
          font-weight: 700;
          font-size: .85rem;
          width: 1.6rem;
          height: 1.6rem;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .mcb-price {
          font-size: 1rem;
          font-weight: 600;
        }
        .mcb-right {
          display: flex;
          gap: .5rem;
          align-items: center;
        }
        .mcb-btn {
          background: #fff;
          color: #111;
          border: none;
          border-radius: 8px;
          padding: .6rem 1.2rem;
          font-weight: 700;
          font-size: .95rem;
          cursor: pointer;
        }
        .mcb-btn--ghost {
          background: transparent;
          color: #fff;
          border: 1px solid rgba(255,255,255,0.4);
        }
      }
    `;
    document.head.appendChild(style);
  }

  async function updateBar() {
    try {
      const res = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
      const cart = await res.json();
      const bar = document.getElementById(BAR_ID);
      if (!bar) return;

      const count = cart.item_count;
      const price = (cart.total_price / 100).toLocaleString('nl-NL', {
        style: 'currency', currency: 'EUR'
      });

      document.getElementById('mcb-count').textContent = count;
      document.getElementById('mcb-price').textContent = price;
      bar.classList.toggle('mcb-visible', count > 0 && ON_BONBONS());
    } catch (e) {
      console.error('[MobileCartBar]', e);
    }
  }

  // Overschrijf Dawn's open() zodat de drawer niet opent bij plusje op mobiel
  // maar wel via header winkelmandje en "Doosje bekijken"
  function blockDrawerOnMobile() {
    const drawer = document.querySelector('cart-drawer');
    if (!drawer || drawer._originalOpen) return;
    drawer._originalOpen = drawer.open.bind(drawer);
    drawer.open = function (triggerElement) {
      if (ON_BONBONS() && MOBILE()) {
        const isHeaderCart = triggerElement && triggerElement.closest('#cart-icon-bubble, .cart-count-bubble, [href="/cart"]');
        if (!isHeaderCart) return;
      }
      drawer._originalOpen(triggerElement);
    };
  }

  // Luister naar Dawn's cart events
  document.addEventListener('cart:updated', updateBar);
  document.addEventListener('cart:refresh', updateBar);
  document.addEventListener('cart:open', updateBar);

  // Vang fetch naar cart endpoints op voor live update
  const _fetch = window.fetch;
  window.fetch = async function (...args) {
    const res = await _fetch(...args);
    const url = typeof args[0] === 'string' ? args[0] : args[0]?.url || '';
    if (url.includes('/cart/add') || url.includes('/cart/change') || url.includes('/cart/update')) {
      setTimeout(updateBar, 400);
    }
    return res;
  };

  function init() {
    if (MOBILE()) {
      injectBar();
      blockDrawerOnMobile();
    }
    updateBar();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();